export default __webpack_public_path__ + "static/media/Close-dark.bee997fc.svg";